import React, { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";

import {
  PageContent,
  HubButtonGroupSlider,
  HubButton,
  HubCardStack,
} from "../../components";
import {
  useGetNotifications,
  usePutMarkAllRead,
  usePutMarkRead,
  useDeleteDismissAllRead,
} from "../../hooks/react-query/useNotificationsData";
import NotificationItem from "../../components/Notifications/NotificationItem";

const tabs = [
  { id: "all", label: "All" },
  { id: "unread", label: "Unread" },
];

export const NotificationsPage = () => {
  const [filter, setFilter] = useState("all");
  const [limit, setLimit] = useState(30);

  const { data: notifications, isLoading } = useGetNotifications({
    limit,
    unreadOnly: filter === "unread",
  });
  const { mutate: markAllRead } = usePutMarkAllRead();
  const { mutate: markRead } = usePutMarkRead();
  const { mutate: dismissAllRead } = useDeleteDismissAllRead();

  return (
    <PageContent>
      <HubCardStack gap="16px" maxWidth="1000px" margin="0 auto" width="100%">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="boldCaptionL" fontSize={20}>
            Notifications
          </Typography>
          <Stack direction="row" gap="12px">
            <HubButton
              size="xsmall"
              variant="text"
              color="neutral"
              icon="Check"
              onClick={() => markAllRead()}
              iconProps={{ size: "14px" }}
            />
            <HubButton
              size="xsmall"
              variant="text"
              color="neutral"
              icon="XCircle"
              onClick={() => dismissAllRead()}
              iconProps={{ size: "14px" }}
            />
          </Stack>
        </Stack>

        <HubButtonGroupSlider
          buttons={tabs}
          selected={filter}
          setSelected={setFilter}
          sx={{ width: "fit-content" }}
        />

        <Stack gap="4px">
          {isLoading && (
            <Typography
              variant="caption"
              fontSize={11}
              color="text.secondary"
              py="20px"
              textAlign="center"
            >
              Loading...
            </Typography>
          )}
          {!isLoading && !notifications?.length && (
            <Typography
              variant="caption"
              fontSize={12}
              color="text.secondary"
              py="40px"
              textAlign="center"
            >
              {filter === "unread"
                ? "No unread notifications"
                : "No notifications yet"}
            </Typography>
          )}
          {notifications?.map((delivery) => (
            <NotificationItem
              key={delivery.id}
              delivery={delivery}
              onRead={(id) => markRead(id)}
            />
          ))}
          {notifications?.length >= limit && (
            <Button
              size="small"
              onClick={() => setLimit((l) => l + 30)}
              sx={{
                fontSize: 11,
                textTransform: "none",
                alignSelf: "center",
                mt: "8px",
              }}
            >
              Load more
            </Button>
          )}
        </Stack>
      </HubCardStack>
    </PageContent>
  );
};

export default NotificationsPage;
